module.exports = __webpack_public_path__ + "static/media/hamburger_icon_dark.683f00e4.svg";